import React from 'react';

export default ({
	title,
	subtitle,
	description,
}) => (
	<div className="mt10 mb10 grid-container contained">
		<div className="row pt5--md">
			<div className="col c6--md c5--lg">
				<h2 className="domaine--large mb3 mb0--md">
					{title}
				</h2>
			</div>

			<div className="col c1 show--lg" />

			<div className="col c6--md">
				<h3 className="fw--600 uppercase mt1--md mb1">
					{subtitle}
				</h3>
				<p className="color--gray-text ws--pre-line hide--md">
					{description}
				</p>
				<p className="color--gray-text ws--pre-line sans--medium show--md">
					{description}
				</p>
			</div>
		</div>
	</div>
);